export default __webpack_public_path__ + "static/media/google-logo.10804027.png";